import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { MasterDataService } from '../masterdata/masterdata.service';
import { Chemical } from '../masterdata/models/chemical';
import { MessagesService } from '../messages/messages.service';
import { BeadChip } from '../models/bead-chip';
import { Plate } from '../models/plate';
import { ErrorHandler } from '../utils/error-handler';
import { MultiBeadChipProcessStepChemicalsDTO, MultiPlateProcessStepChemicalsDTO, ProcessStepChemicalsDTO } from './chemicals-dto';
import { MaChemicalsPopupService } from './ma-chemicals-popup.service';

@Component({
  selector: 'app-ma-chemicals-popup',
  templateUrl: './ma-chemicals-popup.component.html',
  styleUrls: ['./ma-chemicals-popup.component.css']
})
export class MaChemicalsPopupComponent implements OnInit {

  constructor(private chemicalService: MaChemicalsPopupService, private _messagesService: MessagesService, private masterDataService: MasterDataService) { }

  errorHandler: ErrorHandler = new ErrorHandler;
  puid :string ="";
  selectedLabId : string ="";
  extraLots: any;
  chemicalValues : any;
  showChemicalDescription: any;
  chemicalSave: boolean;
  selectedProcess: string;

  @Input() dialogOpen: boolean;
  @Input() isPlate: boolean;
  @Input() noChemicalEdit : boolean;
  @Input() processStepChemicals : Array<Chemical>;
  @Input() selectedPlate: Plate;
  @Input() selectedBatch: Covid19Batch;
  @Input() selectedBeadChip: BeadChip;
  @Input() selectedProcessStep : string;
  @Input() multiChemicals: boolean;
  @Input() plateids: any[] = [];
  @Input() beadchipids: any[] = [];
  @Output() backButtonEmitter = new EventEmitter<any>();

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedProcess = localStorage.getItem('process');
    this.chemicalSave = false;
  }

  disableFields(){
    if(this.multiChemicals && (this.plateids.length>0 || this.beadchipids.length>0)){
      return false;
    }
    else{
      return this.noChemicalEdit
    }
  }

  popSaveDisable(){
    return this.noChemicalEdit || !( this.noChemicalEdit || this.chemicalSave);
  }

  popMultiSaveDisable(){
    return !this.chemicalSave;
  }

  validateLotValues() {
    if(this.processStepChemicals.length==0){
      this.chemicalSave = false;
      return;
    }
    this.chemicalSave = true;
    this.processStepChemicals.forEach(
      (processStepChemical) => {
        let chemicalName = processStepChemical.chemicalName;
        this.chemicalValues[chemicalName].forEach(
          (value) => {
            if(value == undefined || value == null || value == ''){
              this.chemicalSave = false;
            }
          }
        );
      }
    );
  }

  updateChemicals(){
    let updatedProcessStepChemicalValues = new ProcessStepChemicalsDTO();
    updatedProcessStepChemicalValues.processStep = this.selectedProcessStep;
    this.processStepChemicals.forEach(
      (processStepChemical) => {
        let chemicalName = processStepChemical.chemicalName;
        let chemicalObject = {};
        chemicalObject['chemical'] = chemicalName;
        chemicalObject['lots'] = this.chemicalValues[chemicalName].slice(0,Number.parseInt(this.extraLots[chemicalName])+1);
        updatedProcessStepChemicalValues.chemicals.push(chemicalObject);
      }
    );
    if(this.selectedProcess=='NGS'){
      this.chemicalService.updateChemicalForNGS(updatedProcessStepChemicalValues, this.selectedLabId, this.selectedBatch.batchID).subscribe(
        (result)=>{
          this.selectedBatch = result.data;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Chemical Lots Updated Successfully!" });
          this.processStepChemicals = undefined;
          this.extraLots = undefined;
          this.chemicalSave = false;
          this.showChemicalDescription = undefined;
          this.chemicalValues = undefined;
          this.backButtonEmitter.emit(this.selectedBatch);
        }
      )
    }else{
      if(this.multiChemicals){
        this.updateMultiChemicals(updatedProcessStepChemicalValues);
      }
      else{
        if(this.isPlate){
          this.chemicalService.updateChemical(updatedProcessStepChemicalValues, this.selectedLabId, this.selectedPlate.plateID).subscribe(
            (result) =>{
              this.selectedPlate = result;
              this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Chemical Lots Updated Successfully!" });
              this.processStepChemicals = undefined;
              this.extraLots = undefined;
              this.chemicalSave = false;
              this.showChemicalDescription = undefined;
              this.chemicalValues = undefined;
              this.backButtonEmitter.emit(this.selectedPlate);      
            },
            (error) =>{
              this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
            }
          );
        }
        else{
          this.chemicalService.updateBeadChipChemical(updatedProcessStepChemicalValues, this.selectedLabId, this.selectedBeadChip.sourcePlateID, this.selectedBeadChip.beadChipID).subscribe(
            (result) =>{
              this.selectedBeadChip = result;
              this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Chemical Lots Updated Successfully!" });
              this.processStepChemicals = undefined;
              this.extraLots = undefined;
              this.chemicalSave = false;
              this.showChemicalDescription = undefined;
              this.chemicalValues = undefined;
              this.backButtonEmitter.emit(this.selectedBeadChip );
            },
            (error) =>{
              this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
            }
          );
        }
      }
    }
  }

  updateMultiChemicals(updatedProcessStepChemicalValues){
    if(this.isPlate){
      let updatedMultiPlateProcessStepChemicalValues = new MultiPlateProcessStepChemicalsDTO();
      updatedMultiPlateProcessStepChemicalValues.chemicals = updatedProcessStepChemicalValues.chemicals;
      updatedMultiPlateProcessStepChemicalValues.processStep = updatedProcessStepChemicalValues.processStep;
      updatedMultiPlateProcessStepChemicalValues.labid = this.selectedLabId;
      updatedMultiPlateProcessStepChemicalValues.plateids = this.plateids;
      this.chemicalService.updateMultiPlateChemical(updatedMultiPlateProcessStepChemicalValues).subscribe(
        (result) =>{
          this.selectedPlate = result;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Chemical Lots Updated Successfully!" });
          this.processStepChemicals = undefined;
          this.extraLots = undefined;
          this.chemicalSave = false;
          this.showChemicalDescription = undefined;
          this.chemicalValues = undefined;
          this.backButtonEmitter.emit(this.selectedPlate);        
        },
        (error) =>{
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      );
    }
    else{
      let updatedMultiBeadChipProcessStepChemicalValues = new MultiBeadChipProcessStepChemicalsDTO;
      updatedMultiBeadChipProcessStepChemicalValues.chemicals = updatedProcessStepChemicalValues.chemicals;
      updatedMultiBeadChipProcessStepChemicalValues.processStep = updatedProcessStepChemicalValues.processStep;
      updatedMultiBeadChipProcessStepChemicalValues.labid = this.selectedLabId;
      updatedMultiBeadChipProcessStepChemicalValues.beadchipids = this.beadchipids;
      this.chemicalService.updateMultiBeadChipChemical(updatedMultiBeadChipProcessStepChemicalValues).subscribe(
        (result) =>{
          this.selectedBeadChip = result;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: "Chemical Lots Updated Successfully!" });
          this.processStepChemicals = undefined;
          this.extraLots = undefined;
          this.chemicalSave = false;
          this.showChemicalDescription = undefined;
          this.chemicalValues = undefined;
          this.backButtonEmitter.emit(this.selectedBeadChip );
        },
        (error) =>{
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
        }
      );
    }
  }

  closePopUp(){
    this.processStepChemicals = undefined;
    this.extraLots = undefined;
    this.chemicalSave = false;
    this.showChemicalDescription = undefined;
    this.chemicalValues = undefined;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  processStepChemicalsPresentOrNot(){
    if(!this.dialogOpen){
      this.closePopUp()
    }
    if(this.processStepChemicals !== undefined){
      if(this.extraLots === undefined && this.chemicalValues === undefined){
        this.extraLots = {};
        this.chemicalValues = {};
        this.showChemicalDescription = {};
        let plateChemicalValues;
        if(this.selectedProcess=='NGS'){
          plateChemicalValues = this.getChemicalValuesFromNGSBatch(this.selectedBatch, this.selectedProcessStep);
        }else{
          if(this.isPlate)
            plateChemicalValues= this.getChemicalValuesFromPlate(this.selectedPlate, this.selectedProcessStep);
          else
            plateChemicalValues= this.getChemicalValuesFromBeadChip(this.selectedBeadChip, this.selectedProcessStep);
        }
        this.processStepChemicals.forEach(
          (processStepChemical) => {
            let chemicalName = processStepChemical.chemicalName;
            this.showChemicalDescription[chemicalName] = true;
            if(plateChemicalValues === undefined || plateChemicalValues.length == 0){
              this.extraLots[chemicalName] = 0;
              this.chemicalValues[chemicalName] = [undefined];
            }
            else{
              let plateChemicalLots = plateChemicalValues.filter(lots => (lots.chemical === chemicalName))
              if (plateChemicalLots.length !=0){
                plateChemicalLots =  plateChemicalLots[0]['lots'];
                if(plateChemicalLots.length === 0){
                  this.extraLots[chemicalName] = 0;
                  this.chemicalValues[chemicalName] = [undefined];
                }
                else{
                  this.extraLots[chemicalName] = plateChemicalLots.length-1;
                  this.chemicalValues[chemicalName] = plateChemicalLots;
                }
              }
              else{
                this.extraLots[chemicalName] = 0;
                this.chemicalValues[chemicalName] = [undefined];
              }
            }
          }
        );
        this.validateLotValues();
        plateChemicalValues = undefined;
      }
      return true;
    }
    return false;
  }

  addLotDetails(chemicalName: string){
    this.extraLots[chemicalName] += 1;
    this.chemicalValues[chemicalName].push(undefined);
    this.validateLotValues();
  }

  removeLotDetails(chemicalName: string, i){
    this.chemicalValues[chemicalName].splice(i+1,1);
    this.extraLots[chemicalName] -= 1;
    this.validateLotValues();
  }

  getChemicalValuesFromBeadChip(beadChip: BeadChip, processStepName: string){
    if (beadChip.beadChipID !== undefined){
      let processStep = beadChip.processSteps.filter(processStep => (processStep.step == processStepName));
      if(processStep.length != 0 && processStep[0].chemicals != undefined){
        return processStep[0].chemicals;
      }
    }
    return undefined;
  }

  getChemicalValuesFromNGSBatch(batch: Covid19Batch, processStepName: string){
    if(batch.batchID!==undefined){
      let processStep = batch.processSteps.filter(ps => (ps.step==processStepName));
      if(processStep.length != 0 && processStep[0].chemicals != undefined){
        return processStep[0].chemicals;
      }
    }
    return undefined;
  }

  getChemicalValuesFromPlate(plate: Plate, processStepName: string){
    if (plate.plateID !== undefined){
      let processStep = plate.processSteps.filter(processStep => (processStep.step == processStepName));
      if(processStep.length != 0 && processStep[0].chemicals != undefined){
        return processStep[0].chemicals;
      }
    }
    return undefined;
  }

  showChemicalDetails(chemicalName: string){
    this.showChemicalDescription[chemicalName] = this.showChemicalDescription[chemicalName] ? false : true;
  }
}
